import Form from "./form";
import { useAttendanceLocalServiceCreate } from "../../../../../../../services/api-tansquery/attendance-local/service/create";

type Props = {
    slug: string;
    buttonTrigger?: React.ReactNode;
};

export default function ServiceFormCreate(props: Props) {
    const mutation = useAttendanceLocalServiceCreate();

    return (
        <Form
            {...props}
            mutation={mutation}
        />
    );
}
